export default {
    methods: {
        getNumberOfFolios: function (numberOfWords) {
            if (numberOfWords === null) return null;
            if (numberOfWords === 0) return 0;
            if (this.$config && this.$config.wordsPerFolio) {
                if (numberOfWords < this.$config.wordsPerFolio) return 1;
                var numberOfFolios = Math.floor(numberOfWords / this.$config.wordsPerFolio);
                var modulo = numberOfWords % this.$config.wordsPerFolio;
                if (modulo > (this.$config.wordsPerFolio - modulo)) numberOfFolios += 1;
                return numberOfFolios;
            }
            return null;
        }
    }
}